module.exports = __webpack_public_path__ + "static/img/5.93950d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Cumplimiento-Disposiciones-Legales/5.png
// module id = AVo+
// module chunks = 0